import {} from 'react';
export const noPropagationMouseEvent = (event) => {
    event?.stopPropagation?.();
    return event;
};
